const name = 'Paytickets';

export const FETCH_TICKETS_REQUEST = `${name}/FETCH_TICKETS_REQUEST`;
export const FETCH_TICKETS_SUCCESS = `${name}/FETCH_TICKETS_SUCCESS`;
export const FETCH_TICKETS_FAILURE = `${name}/FETCH_TICKETS_FAILURE`;



// WEBPACK FOOTER //
// ./src/sites/payTickets/constants.js